export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">移动观影</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">随时随地，畅享高清观影体验</p>
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-1 text-center md:text-left">
            <h3 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">小辣椒影院 · 手机端</h3>
            <p className="text-sm text-background-50/90 leading-relaxed mb-5">
              无需下载 APP，手机浏览器直接访问即可享受与电脑端一致的高清观影体验。
              自适应手机屏幕，竖屏横屏自由切换，地铁上、午休时、睡前躺着看，随时随地想追就追。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <a
                href="#hero"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-background-50 text-primary-600 font-medium px-6 py-3 rounded-md text-sm hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                立即访问手机版
              </a>
              <a
                href="#features"
                className="whitespace-nowrap inline-flex items-center gap-2 border border-background-50/30 text-background-50 font-medium px-6 py-3 rounded-md text-sm hover:bg-background-50/10 transition-colors cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 flex items-center justify-center rounded-full bg-background-50/15">
              <i className="ri-smartphone-line text-6xl md:text-7xl text-background-50"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}